<template>
	<span :class="isNotAvailable ? 'invalid_color' : '' ">
		{{ realContent }}
	</span>
</template>

<script>
import {localization} from "@/common/lang/localization";

export default {
	computed: {
		isNotAvailable() {
			let value = this.params.valueFormatted || this.params.value;
			if (!value && value !== 0) {
				return true;
			}
			return value === this.$t("common.value.notAvailable");
		},
		// if there is no valueFormatter for n/a, then this renderer does the formatting instead
		realContent() {
			let displayValue = this.params.valueFormatted || this.params.value;
			if (!displayValue && displayValue !== 0) {
				return this.$t("common.value.notAvailable");
			}
			return displayValue
		}
	}
};
</script>